import { render, staticRenderFns } from "./Product_request.vue?vue&type=template&id=3a0f3930&"
import script from "./Product_request.vue?vue&type=script&lang=js&"
export * from "./Product_request.vue?vue&type=script&lang=js&"
import style0 from "./Product_request.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports